$(document).ready(function () {
    var inProgress = false;
    $('.swiper-container').click(function () {
        if (inProgress)
            return;

        $(this).toggleClass('swiped');
        $(this).parents('.swiper').find('.swiper__list').toggleClass('swiped');
        
        if ($(this).parents('.swiper').find('[data-swipe]').length) {
            var _ = '';
            $(this).parents('.swiper').find('[data-swipe]').each(function () {
                _ = $(this).attr($(this).data('swipe'));
                $(this).attr($(this).data('swipe'), $(this).attr('data-swipe-text'));
                $(this).attr('data-swipe-text', _);
            })
        }

        inProgress = true;
        setTimeout(function () {
            inProgress = false;
        },660);
    });
    
    $('.swiper-main__item--first').click(function () {
        if (inProgress)
            return;

        if ($('.swiper-container').hasClass('swiped')){
            $('.swiper-container').click();

            inProgress = true;
            setTimeout(function () {
                inProgress = false;
            },660);
        }
    });
    
    $('.swiper-main__item--last').click(function () {
        if (inProgress)
            return;

        if (!$('.swiper-container').hasClass('swiped')){
            $('.swiper-container').click();

            inProgress = true;
            setTimeout(function () {
                inProgress = false;
            },660);
        }
    })
});